import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-332a26a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "send-now-link" }
const _hoisted_7 = { class: "shedule-datetime-picker-timezone-label" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "date-time-title" }, "Select date and time", -1))
const _hoisted_9 = { class: "modal-group" }
const _hoisted_10 = {
  key: 0,
  class: "date-time-error"
}
const _hoisted_11 = {
  key: 1,
  class: "date-time-timezone"
}
const _hoisted_12 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Modal, {
          "small-header": "",
          "allow-click-out": "",
          top: 20,
          padding: 14,
          size: _ctx.modalSize.Small,
          show: _ctx.showPredefinedDatePicker,
          close: _ctx.onClose
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pickerOptions, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.name,
                class: "schedule-datetime-picker-item",
                onClick: ($event: any) => (_ctx.onClickOption(item))
              }, [
                _createElementVNode("img", {
                  src: item.icon
                }, null, 8, _hoisted_3),
                _createElementVNode("p", {
                  class: "schedule-datetime-picker-item-name",
                  innerHTML: item.name
                }, null, 8, _hoisted_4),
                _createElementVNode("p", {
                  class: "schedule-datetime-picker-item-time",
                  innerHTML: item.displayTime
                }, null, 8, _hoisted_5)
              ], 8, _hoisted_2))
            }), 128)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickOption({ name: 'Now', time: '' })))
              }, "Now")
            ]),
            _createElementVNode("p", _hoisted_7, " All times are in " + _toDisplayString(_ctx.timezone) + " Time ", 1)
          ], undefined, true),
          _: 1
        }, 8, ["size", "show", "close"]),
        _createVNode(_component_Modal, {
          top: 20,
          padding: 24,
          size: _ctx.modalSize.Small,
          show: _ctx.showCustomDateTimePicker
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.customDateTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customDateTime) = $event)),
                modelModifiers: { string: true },
                mode: "datetime",
                color: "blue",
                "first-day-of-week": 2,
                masks: _ctx.datePickerMasks,
                "is-required": ""
              }, null, 8, ["modelValue", "masks"]),
              (_ctx.customDateTimePickerError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "     " + _toDisplayString(_ctx.customDateTimePickerError), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, "     " + _toDisplayString(_ctx.timezone) + " Time ", 1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                class: "cancel",
                "no-border": "",
                onClick: _ctx.onCancelSchedule
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ], undefined, true),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                class: "continue",
                onClick: _ctx.onOkSchedule
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Schedule Send")
                ], undefined, true),
                _: 1
              }, 8, ["onClick"])
            ])
          ], undefined, true),
          _: 1
        }, 8, ["size", "show"])
      ]))
    : _createCommentVNode("", true)
}